module.exports = __webpack_public_path__ + "static/img/Banner_web_nino_redpie.3bae8838.svg";